import React from "react";

const Loans = () => {
  return (
    <section className="grid-section">
      <div className="grid-container">
        <h2>Loans is not currently available.</h2>
      </div>
    </section>
  );
};

export default Loans;
